import axios from "axios";
import { setupCache } from "axios-cache-adapter";
import { globalMessageHandler } from "common";
import I18n from "i18n-js";
import { get } from "lodash";
import constants from "./../constants";

/*const storage = {
  setItem: async (key, data) =>
    await sessionStorage.setItem(key, JSON.stringify(data)),
  getItem: async key => JSON.parse(await sessionStorage.getItem(key)),
  removeItem: sessionStorage.removeItem,
  clear: sessionStorage.clear,
  length: sessionStorage.length
};*/

const cache = setupCache({
  maxAge: 15 * 60 * 1000,
  ignoreCache: true,
  exclude: {
    // {Array} List of regular expressions to match against request URLs.
    //paths: [],
    // {Boolean} Exclude requests with query parameters.
    query: false,
    // {Function} Method which returns a `Boolean` to determine if request
    // should be excluded from cache.
    //filter: null
  },
  //store: storage
  /*invalidate: async (cfg, req) => {
    
    const method = req.method.toLowerCase();
    if (method !== "get") {
      await cfg.store.removeItem(cfg.uuid);
    }
  }*/
});

export const api = axios.create({
  baseURL: constants.apiHost,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
  timeout: 120000,
  adapter: cache.adapter,
});

let store;

export const injectStore = _store => {
  store = _store;
};

api.interceptors.request.use(config => {
  const access_token = get(store.getState(), "identity.data.access_token");
  config.headers.Authorization = `Bearer ${access_token}`;
  return config;
});

//Process response and retun a custom structure
api.interceptors.response.use(
  response => {
    //custom response formatting
    return {
      data: response.data,
      success: response.hasOwnProperty("success") ? response.success : true,
      status: response.status,
    };
  },
  async error => {
    const url = get(error, "response.config.url");
    let status = get(error, "response.status", 0);

    //Auth error
    if (status === 401) {
      if (url === constants.auth.url) {
        //Login action
      } else {
        //Other action, remove expired token
        await store.dispatch({ type: "identity/logout/fulfilled" });
        globalMessageHandler.error(I18n.t("App.tokenExpired"));
        return { success: false };
      }
    }

    //Global confirm warning
    if (status === 406) {
      const messages = get(error, "response.data.messages", []);
      let promise = new Promise(function (resolve, reject) {
        globalMessageHandler.confirm(
          messages,
          () => {
            resolve(true);
          },
          () => {
            resolve(false);
          }
        );
      });
      const confirmResult = await promise;
      if (confirmResult) {
        error.config.headers["X-Warnings"] = "confirmed";
        return api.request(error.config);
      } else {
        return {
          success: false,
        };
      }
    }

    if (error.response && error.response.data) {
      //Get success
      const success = get(error, "response.success", false);

      //Get error message in various cases
      const errorMessageKeys = ["reason", "error_message", "message"];
      let message = "Unknown error happend";
      for (let i in errorMessageKeys) {
        const key = errorMessageKeys[i];
        if (error.response.data.hasOwnProperty(key)) {
          message = error.response.data[key];
          break;
        }
      }

      //Handle global errors except form errors
      if (!error.response.data.form_errors) {
        globalMessageHandler.fatalError(message);
      }
      return { success, message, status, data: error.response.data };
    }
    const message = get(error, "message", "Unknown error happend.");
    globalMessageHandler.fatalError(message);
    return {
      success: false,
      message,
      status,
    };
  }
);
export default api;
